import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ChangeEmail from './ChangeEmail';
import ForgotPassword from './Forgot';
import ResetPassword from './ResetPassword';
import SignIn from './SignIn';
import SignUp from './SignUp';
import Verify from './Verify';

const AuthRouter = () => (
  <Routes>
    <Route path="*" element={<SignIn />} />
    <Route path="signup" element={<SignUp />} />
    <Route path="verify" element={<Verify />} />
    <Route path="change-email" element={<ChangeEmail />} />
    <Route path="resetpassword" element={<ResetPassword />} />
    <Route path="forgotpassword" element={<ForgotPassword />} />
  </Routes>
);

export default AuthRouter;
